// src/screens/Login.js v1.7
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { APP_VERSION } from '../database/db';

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const r = await login(username, password);
    if (r && r.success) {
      navigate('/dashboard');
    } else {
      setError(r?.error || 'Invalid credentials');
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center', background:'var(--bg-base)', padding:20 }}>
      <div style={{ width:'100%', maxWidth:440 }}>
        {/* Logo */}
        <div style={{ textAlign:'center', marginBottom:36 }}>
          <div style={{ fontSize:72, marginBottom:14 }}>🅿️</div>
          <div style={{ fontFamily:'var(--font-display)', fontSize:34, fontWeight:800, letterSpacing:'0.02em' }}>
            <span style={{ color:'var(--accent)' }}>PARK</span>
            <span style={{ color:'var(--text-primary)' }}>SMART PRO</span>
          </div>
          <div style={{ fontSize:12, color:'var(--text-muted)', marginTop:8, fontFamily:'var(--font-mono)', letterSpacing:'0.1em' }}>
            AL BARAKAH CAR PARKING · SHARJAH
          </div>
        </div>

        {/* Login Card */}
        <div className="card">
          <div style={{ fontSize:12, color:'var(--text-muted)', fontFamily:'var(--font-mono)', textTransform:'uppercase', letterSpacing:'0.1em', marginBottom:20 }}>
            Staff Sign In
          </div>

          {error && (
            <div className="alert alert-danger" style={{ marginBottom:16, fontSize:14 }}>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">Username</label>
              <input
                className="form-input"
                type="text"
                placeholder="Enter username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                required
                autoFocus
                autoCapitalize="none"
                autoCorrect="off"
                style={{ fontSize:18, padding:'16px' }}
              />
            </div>

            <div className="form-group">
              <label className="form-label">Password</label>
              <input
                className="form-input"
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                required
                style={{ fontSize:18, padding:'16px' }}
              />
            </div>

            <button
              type="submit"
              className="btn btn-primary btn-full"
              disabled={loading}
              style={{ marginTop:12, padding:'18px', fontSize:18, fontWeight:700, borderRadius:'var(--radius)' }}
            >
              {loading ? '⏳ Signing in...' : '🔐 Sign In'}
            </button>
          </form>
        </div>

        <div style={{ textAlign:'center', marginTop:20, fontSize:11, color:'var(--text-muted)', fontFamily:'var(--font-mono)' }}>
          {APP_VERSION} · parksmartpro.com
        </div>
      </div>
    </div>
  );
}
